import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 flex flex-col justify-start items-center h-52" }
const _hoisted_2 = { class: "w-full flex items-center justify-between" }
const _hoisted_3 = { class: "w-full mt-6" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "w-full flex items-center justify-between bg-wrh-blue-background py-3 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-wrh-green-dark" }
const _hoisted_6 = { class: "flex items-center justify-start space-x-2" }


import CalenderIcon from '../../../components/icons/CalenderIcon.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props


const appointTitle = 'My Appointments';
const appointLink = 'View All';
const appointName = 'Meeting with Project Manager';
const appointTime = '10:00 am';
const appointDime = '5/16';

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", { class: "t-22m text-wrh-blue-dark" }, _toDisplayString(appointTitle)),
      _createVNode(_component_router_link, {
        class: "t-14r text-wrh-blue-light capitalize",
        to: `/homes/${props.homeId}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(appointLink))
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(CalenderIcon, { class: "w-5 h-5 text-wrh-blue-light" }),
            _createElementVNode("span", { class: "t-14m text-wrh-gray-dark font-normal" }, _toDisplayString(appointName))
          ]),
          _createElementVNode("div", { class: "flex items-baseline justify-end space-x-2" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "inline-flex items-center t-12m px-2.5 py-0.75 rounded-full bg-wrh-blue-light text-white" }, _toDisplayString(appointTime))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", { class: "t-12r text-wrh-gray-dark" }, _toDisplayString(appointDime))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})